/**
 * Client-side associate-dashboard authorization check (RepDashboard.tsx).
 *
 * rep.getByCode (server/routers.ts) returns the FULL rep record — which
 * always includes the `username` key, even when its value is null for a rep
 * still pending credentials — only to the rep themselves or an admin. Every
 * other caller gets a redacted, public-safe subset that never contains that
 * key at all. Checking KEY PRESENCE (not truthiness of the value) is what
 * makes this correct for a legitimately self-viewing rep who has no
 * credentials yet.
 *
 * This deliberately does NOT depend on the error state of any other query
 * (commission summary, downline, agreement, etc.) — a prior version of this
 * gate did, and that "shows the dashboard unless some other query is caught
 * failing" design flickered open in production: on first paint, or during
 * any of those queries' automatic retry/refetch cycles, their `.error` can
 * be transiently unset even for a genuinely denied caller. A dashboard is a
 * "prove you're allowed in" surface, not a "we haven't caught you yet" one —
 * this function is the single, deterministic source of truth for that,
 * derived from the exact same query that already has to succeed for the
 * page to render anything at all.
 */
export function isFullRepRecord(rep: unknown): boolean {
  return rep != null && typeof rep === "object" && "username" in rep;
}
